import React from 'react';
import styled from 'styled-components';
import { IPageBuilderHeaderPreviewProps } from './IPageBuilderHeaderPreviewProps';
import { BlockButtonsContainer, BlockSideButton } from '../ButtonBlockPreview/ButtonBlockPreview';
import BlockButton from '../BlockComponents/BlockButton';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import useWindowSize from 'utils/windowSize';
import { LivePagePreviewView } from 'containers/PageBuilder/LivePagePreviewContainer/domain';
import MenuIcon from './icons/MenuIcon';
import { ButtonAction, HeaderBehavior, scrollElementIntoView } from 'containers/PageBuilder/SinglePageContainer/domain';
import miscUtils from 'utils/miscUtils';

const HeaderContainer: any = styled.div<{design: any}>`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: ${(props) => 
        props.design.container_height ?
        `${props.design.container_height}px`:
        `50px`
    };
    background-color: ${(props) => 
        props.design.container_background_color &&
        isValidHexColor(props.design.container_background_color) ?
        props.design.container_background_color :
        'transparent'
    };
    border-bottom-width: ${(props) => 
        props.design.container_border_bottom_width ?
        `${props.design.container_border_bottom_width}px` :
        `0px`
    };
    border-bottom-style: solid;
    border-bottom-color: ${(props) =>
        props.design.container_border_bottom_color &&
        isValidHexColor(props.design.container_border_bottom_color) ?
        props.design.container_border_bottom_color :
        `transparent`
    };
    box-shadow: ${(props) => 
        props.design.container_shadow_color &&
        isValidHexColor(props.design.container_shadow_color) ?
        `0px 4px 8px rgba(${miscUtils.hexToRgb(props.design.container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.container_shadow_color)!.b}, ${props.design.container_shadow_opacity ? props.design.container_shadow_opacity : 0.0})` :
        'none'
    };
    z-index: ${(props) =>
        props.design.header_behavior === HeaderBehavior.Sticky ?
        '2' :
        'auto'
    };
`;

const HeaderWrapper: any = styled.div<{design: any}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: ${(props) =>
        props.design.content_container_max_width ?
        `${props.design.content_container_max_width}px` :
        `1150px`
    };
    padding-left: ${(props) => 
        props.design.container_padding_left ?
        `${props.design.container_padding_left}px` :
        `0px`
    };
    padding-right: ${(props) => 
        props.design.container_padding_right ?
        `${props.design.container_padding_right}px` :
        `0px`
    };

    &.mobile {
        padding-left: ${(props) => 
            props.design.container_padding_left &&
            props.design.container_padding_left > 15 ?
            `${props.design.container_padding_left}px` :
            `15px`
        };
        padding-right: ${(props) => 
            props.design.container_padding_right &&
            props.design.container_padding_right > 15 ?
            `${props.design.container_padding_right}px` :
            `15px`
        };
    }

    @media(max-width: 550px) {
        padding-left: ${(props) => 
            props.design.container_padding_left &&
            props.design.container_padding_left > 15 ?
            `${props.design.container_padding_left}px` :
            `15px`
        };
        padding-right: ${(props) => 
            props.design.container_padding_right &&
            props.design.container_padding_right > 15 ?
            `${props.design.container_padding_right}px` :
            `15px`
        };
    }
`;

const HeaderLeftContainer: any = styled.div`
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const HeaderLogoImage: any = styled.img<{design: any}>`
    height: ${(props) => 
        props.design.logo_height ?
        `${props.design.logo_height}px`:
        `50px`
    };
    width: auto;
    cursor: pointer;
    margin-right: 50px;
`;

const HeaderCenterContainer: any = styled.div`
    display: flex;
    flex-direction: row;
    width: fit-content;
    align-items: center;

    @media(max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        margin: 10px 0;
    }

    &.mobile {
        flex-direction: column;
        align-items: flex-start;
        margin: 10px 0;
    }
`;

const HeaderLinksWrapper: any = styled.div<{design: any}>`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    column-gap: ${(props) => 
        props.design.link_margin ?
        `${props.design.link_margin}px` :
        `35px`
    };
    row-gap: 5px;
`;

const HeaderCenterLink: any = styled.p<{design: any, index?: number}>`
    margin: 0;
    padding: 0;
    font-family: ${(props) => 
        props.design.link_text_font_family ?
        `${props.design.link_text_font_family} !important` :
        `-apple-system, Arial !important`
    };
    font-size: ${(props: any) =>
        props.design.link_text_font_size ?
        `${props.design.link_text_font_size}px` :
        `18px`
    };
    line-height: ${(props: any) =>
        props.design.link_text_line_height ?
        `${props.design.link_text_line_height}px` :
        `25px`
    };
    color: ${(props) => 
        props.design.link_text_color &&
        isValidHexColor(props.design.link_text_color) ?
        props.design.link_text_color :
        '#365DE6'
    };
    cursor: pointer;
    transition: .5s;

    @media(max-width: 768px) {
        margin-right: 0;
        margin-top: ${(props) => 
            props.index ? 
            `20px` :
            '0'
        };
    }

    &.mobile {
        margin-right: 0;
        margin-top: ${(props) => 
            props.index ? 
            `20px` :
            '0'
        };
    }

    &:hover {
        color: ${(props) =>
            props.design.link_text_hover_color &&
            isValidHexColor(props.design.link_text_hover_color) ?
            props.design.link_text_hover_color :
            props.design.link_text_color &&
            isValidHexColor(props.design.link_text_color) ?
            props.design.link_text_color :
            `inherit`
        };
    }
`;

const HeaderRightContainer: any = styled.div`

`;

const HeaderIconContainer: any = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const HeaderPopupContainer: any = styled.div<{design: any, headerHeight: number}>`
    z-index: 2147483647;
    position: absolute;
    top: ${(props) =>
        `${props.headerHeight}px`
    };
    right: 0;
    left: 0;
    width: 100%;
    padding: 20px 0;
    padding-left: 10px;
    padding-right: 10px;
    background-color: ${(props) => 
        props.design.container_background_color &&
        isValidHexColor(props.design.container_background_color) ?
        props.design.container_background_color :
        '#FAFAFA'
    };
`;


const RESPONSIVE_BREAKPOINT: number = 768;

const PageBuilderHeaderPreview: React.FC<IPageBuilderHeaderPreviewProps> = (props) => {

    const windowSize = useWindowSize();

    const headerElementRef = React.useRef<any>(null);

    const [headerHeight, setHeaderHeight] = React.useState<number>(0);
    const [open, setOpen] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (headerElementRef.current) {
        const headerElementHeight = headerElementRef.current.offsetHeight;
        setHeaderHeight(headerElementHeight);
        }
    }, [headerElementRef.current]);

    const ctaOnClick = (blockData: any, clickableKey: string, useLink?: boolean) => {
        if(props.buildingPreview) {
            return;
        }

        if(open) {
            setOpen(false);
        }
    
        if(
            blockData &&
            (
                blockData[`${clickableKey}_action`] === ButtonAction.URL ||
                blockData[`${clickableKey}_action`] === ButtonAction.URLTab
            ) &&
            blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]
        ) {
            window.open(
                miscUtils.ensureHttps(blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]), 
                blockData[`${clickableKey}_action`] === ButtonAction.URLTab ?
                '_blank' :
                '_self'
            );
            return;
        }
    
        if(
            blockData &&
            blockData[`${clickableKey}_action`] === ButtonAction.Scroll &&
            blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`] &&
            props.containerBaseIdName
        ) {
            scrollElementIntoView(`${props.containerBaseIdName}${blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]}`);
            return;
        }
    
        if(
            blockData &&
            blockData[`${clickableKey}_action`] === ButtonAction.Popup &&
            blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]
        ) {
            let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));
    
            nextPageFormsOpenState[blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]] = true;
    
            props.setPageFormsOpenState(nextPageFormsOpenState);
            return;
        }

        if(
            blockData &&
            blockData[`${clickableKey}_action`]  === ButtonAction.Page &&
            blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`] 
        ) {
            window.open(
                `${blockData[`${clickableKey}_${useLink ? 'link' : 'url'}`]}`,
                '_self'
            );
            return;
        }
    }

    if(windowSize.width <= RESPONSIVE_BREAKPOINT || props.view === LivePagePreviewView.Mobile) {
        return (
            <HeaderContainer
            ref={headerElementRef}
            design={props.headerData.design}
            >
                <HeaderWrapper
                className={props.view ? `${props.view}` : ''}
                design={props.headerData.design}
                >
                    <HeaderLeftContainer
                    >
                        {props.headerData.left.logo_url ? (
                            <HeaderLogoImage
                            src={props.headerData.left.logo_url}
                            design={props.headerData.design}
                            onClick={() => ctaOnClick(props.headerData.left, 'image', true)}
                            />
                        ) : <></>}
                    </HeaderLeftContainer>

                    <HeaderIconContainer
                    onClick={() => setOpen(!open)}
                    >
                        <MenuIcon
                        stroke={
                            props.headerData.design.menu_icon_color &&
                            isValidHexColor(props.headerData.design.menu_icon_color) ?
                            props.headerData.design.menu_icon_color :
                            '#000000'
                        }
                        />
                    </HeaderIconContainer>
                </HeaderWrapper>
                {open ? (
                    <HeaderPopupContainer
                    design={props.headerData.design}
                    headerHeight={headerHeight}
                    >
                        <HeaderCenterContainer
                        className={props.view ? `${props.view}` : ''}
                        >
                            {props.headerData.center.links.map((link: any, index: number) => (
                                <HeaderCenterLink
                                key={link.render_id}
                                className={props.view ? `${props.view}` : ''}
                                design={props.headerData.design}
                                index={index}
                                onClick={() => ctaOnClick(link, 'link')}
                                >
                                    {link.link_text}
                                </HeaderCenterLink>
                            ))}
                        </HeaderCenterContainer>

                        <HeaderRightContainer
                        >
                            <BlockButtonsContainer
                            className={props.view ? `${props.view}` : ''}
                            >
                                <BlockButton
                                design={props.headerData.design}
                                pageStyles={props.pageStyles}   
                                customStyles={{
                                    marginTop: '10px',
                                    padding: '10px 20px',
                                    width: '100%',
                                }}
                                    onClick={() => ctaOnClick(props.headerData.right, 'button')}
                                >
                                    {props.headerData.right.button_text}
                                </BlockButton>

                                {props.headerData.right.side_by_side_button ? (
                                    props.headerData.right.side_by_side_buttons.map((side_by_side_button: any, index: number) => (
                                        <BlockSideButton
                                        key={`${index}`}
                                        className={props.view ? `${props.view}` : ''}
                                        design={side_by_side_button.design}
                                        pageStyles={props.pageStyles}
                                        customStyles={{
                                            marginTop: '10px',
                                            padding: '10px 20px',
                                            width: '100%',
                                        }}
                                        onClick={() => ctaOnClick(side_by_side_button, 'button')}
                                        >
                                            {side_by_side_button.button_text}
                                        </BlockSideButton>
                                    ))
                                ) : <></>}
                            </BlockButtonsContainer>
                        </HeaderRightContainer>
                    </HeaderPopupContainer>
                ) : <></>}
            </HeaderContainer>
        )
    }

  return (
    <HeaderContainer
    ref={headerElementRef}
    design={props.headerData.design}
    >
        <HeaderWrapper
        className={props.view ? `${props.view}` : ''}
        design={props.headerData.design}
        >
            <HeaderLeftContainer
            >
                {props.headerData.left.logo_url ? (
                    <HeaderLogoImage
                    src={props.headerData.left.logo_url}
                    design={props.headerData.design}
                    onClick={() => ctaOnClick(props.headerData.left, 'image', true)}
                    />
                ) : <></>}

                <HeaderLinksWrapper
                design={props.headerData.design}
                >
                    {props.headerData.center.links.map((link: any, index: number) => (
                        <HeaderCenterLink
                        key={link.render_id}
                        design={props.headerData.design}
                        onClick={() => ctaOnClick(link, 'link')}
                        >
                            {link.link_text}
                        </HeaderCenterLink>
                    ))}
                </HeaderLinksWrapper>
            </HeaderLeftContainer>

            <HeaderRightContainer
            >
                <BlockButtonsContainer
                >
                    <BlockButton
                    design={props.headerData.design}
                    pageStyles={props.pageStyles}   
                    customStyles={{
                        marginTop: '0px',
                        padding: '10px 20px',
                        whiteSpace: 'nowrap',
                    }}
                    onClick={() => ctaOnClick(props.headerData.right, 'button')}
                    >
                        {props.headerData.right.button_text}
                    </BlockButton>

                    {props.headerData.right.side_by_side_button ? (
                        props.headerData.right.side_by_side_buttons.map((side_by_side_button: any, index: number) => (
                            <BlockSideButton
                            key={`${index}`}
                            design={side_by_side_button.design}
                            pageStyles={props.pageStyles}
                            customStyles={{
                                marginTop: '0px',
                                padding: '10px 20px',
                                whiteSpace: 'nowrap',
                            }}
                            onClick={() => ctaOnClick(side_by_side_button, 'button')}
                            >
                                {side_by_side_button.button_text}
                            </BlockSideButton>
                        ))
                    ) : <></>}
                </BlockButtonsContainer>
            </HeaderRightContainer>
        </HeaderWrapper>
    </HeaderContainer>
  )
}

export default PageBuilderHeaderPreview;